import React from "react";
import { MdErrorOutline } from "react-icons/md";
import styles from "./not-allowed.module.css"

function NotAllowed() {
  return (
    <div className="center-wrapper">
      <div className={["center-container", styles.not_allowed ].join(" ")}>
        <div>
          <MdErrorOutline
            color="#EA9E43"
            style={{ height: "100px", width: "100px" }}
          />
        </div>
        <div>
          <h1>Sorry</h1>
          <p>The action is not possible on your browser. </p>
          <p>Please open the link on your mobile device instead. Thanks.</p>
        </div>
      </div>
    </div>
  );
}

export default NotAllowed;
